import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    connect() {
        this.url = this.element.dataset.url;
        this.checkoutButton = document.querySelector('.checkout-button');
    }

    async toggle(e) {
        const checkbox = e.currentTarget;
        const item = checkbox.closest('.option-item');
        const productId = item && item.dataset.productId;

        if (!productId || !this.url) {
            return;
        }

        checkbox.disabled = true;
        item.classList.add('loading');
        this.disableCheckout();

        try {
            const response = await axios.post(this.url, {
                product_id: Number(productId),
                checked: checkbox.checked,
            });

            const data = response.data && response.data.data;

            if (data && data.general_error) {
                throw new Error(data.general_error);
            }

            window.location.reload();
        } catch (error) {
            checkbox.checked = !checkbox.checked;
            checkbox.disabled = false;
            item.classList.remove('loading');
            this.enableCheckout();
        }
    }

    disableCheckout() {
        if (this.checkoutButton) {
            this.checkoutButton.classList.add('disabled');
            this.checkoutButton.setAttribute('aria-disabled', 'true');
        }
    }

    enableCheckout() {
        if (this.checkoutButton) {
            this.checkoutButton.classList.remove('disabled');
            this.checkoutButton.removeAttribute('aria-disabled');
        }
    }
}
